

<template>
  <div
    v-if="request.requestType === 'PQT'"
    class="my-3"
    style="line-height: 1.5"
  >
    <strong class="text-dark">{{ $t('pqtExtrasView.ilkinZruriRtlr') }}</strong>
    <div>
      <span>{{ $t('pqtExtrasView.valyuta') }} </span>
      <span class="text-dark">{{ requestExtras.currency }}</span>
      <span
        v-if="requestExtras.currencyRequired==='yes'"
        class="badge badge-danger"
      >{{ $t('pqtExtrasView.mtlq') }}</span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.arzuOlunan') }}</span>
    </div>
    <div>
      <span>{{ $t('pqtExtrasView.incotermsRtlri') }} </span>
      <span
        v-if="requestExtras.incoterms !== 'NONE'"
        class="text-dark"
      >
        {{ requestExtras.incoterms }}
        <span
          v-if="requestExtras.incotermsRequired==='yes'"
          class="badge badge-danger"
        >{{ $t('pqtExtrasView.mtlq') }}</span>
        <span
          v-else
          class="badge badge-light"
        >{{ $t('pqtExtrasView.arzuOlunan') }}</span>
      </span>
      <span
        v-else
        class="text-dark"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.dniSulu') }} </span>
      <span class="text-dark">
        <span v-if="requestExtras.payment ==='transfer'">{{ $t('offerExtrasView.krm') }}</span>
        <span v-else-if="requestExtras.payment ==='cash'">{{ $t('offerExtrasView.nad') }}</span>
        <span v-else-if="requestExtras.payment ==='both'">{{ $t('offerExtrasView.hrIkisi') }}</span>
        <span v-else>{{ requestExtras.payment }}</span>
      </span>
      <span
        v-if="requestExtras.paymentRequired==='yes'"
        class="badge badge-danger"
      >{{ $t('pqtExtrasView.mtlq') }}</span>
      <span
        v-else
        class="badge badge-light"
      >{{ $t('pqtExtrasView.arzuOlunan') }}</span>
    </div>
    <div>
      <span>{{ $t('offerExtrasView.atdrlma') }} </span>
      <span
        v-if="requestExtras.deliveryNeeded === 'yes'"
        class="text-dark"
      >
        {{ $t('pqtExtrasView.razlqLdEdildikdnSonraRequestextrasdeliveryGnRzind', {delivery:requestExtras.delivery}) }}
      </span>
      <span
        v-else
        class="text-dark"
      >{{ $t('pqtExtrasView.ehtiyacYoxdur') }}</span>
    </div>

    <div v-if="requestExtras.initialRequirementNotes">
      <span>{{ $t('pqtExtrasView.qeyd') }} </span>
      <span class="text-dark">{{ requestExtras.initialRequirementNotes }}</span>
    </div>
    <div v-if="request.autoWinner">
      <span>{{ $t('pqtExtrasView.method') }} </span>
      <span class="text-dark">{{ request.autoWinner===1? $t('newAUCRequest.manual'):$t('newAUCRequest.automatic') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PQTExtrasView',
  props: {
    request: {},
    requestExtras: {}
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
